import React, { useState, createContext, useContext } from 'react';
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Home from "../pages/Home";
const DashboardLayout = () => {
    
    
  const [currentPage, setCurrentPage] = useState('job-explorer');
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <Home />;      
    }
  };

    return(     
        <div className="flex h-screen bg-[#eff4ff]">
            <Sidebar  />
            <div className="flex-1 flex flex-col overflow-hidden">
            <Topbar />
            <main className="flex-1 p-6 overflow-y-auto">
                {/* 👇 This changes dynamically when route changes */}
                <Outlet />
            </main>
            </div>
        </div>
        );
};    

export default DashboardLayout;
